import { useMutation, useQueryClient } from 'react-query';
import { CCWorkflowsApi } from '../api/ccWorkflows';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';

export const useUpdateTemplateLinks = (itemId: number) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(
    (matrixIds: string[]) => CCWorkflowsApi.putCCWorkflowLink(companyId, itemId, 'document', matrixIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['linked_cc_workflows', companyId]);
        showToast({
          description: t('template.hooks.updateCCLinks.success'),
          status: 'success',
          title: t('common.toast.success'),
          'data-cy': 'toast-update-cc-links-success',
        });
      },
      onError: (error) => {
        showToast({
          description: formErrorMessageForToast(t('template.hooks.updateCCLinks.error'), error),
          status: 'error',
          title: t('common.toast.error'),
          'data-cy': 'toast-update-cc-links-error',
        });
      },
    },
  );
};
